import { Theme, useMediaQuery } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export function useIsMobileSize(breakpoint: Breakpoint = "md"): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down(breakpoint));
}
